var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pdf)?_c('pdf',{attrs:{"src":_vm.pdf,"page":_vm.page ? _vm.page : 1}},[_c('template',{slot:"loading"},[_vm._v(" "+_vm._s(_vm.loadingMessage)+" ")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }